import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Input } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateUser, getUserById } from "../../store/slices/authSlice";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  user: Yup.string().required("Required"),
  email: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  role: Yup.string().required("Required"),
  directory: Yup.string().required("Required"),
  personal_nr: Yup.string().required("Required"),
  position: Yup.string().required("Required"),
});

export default function EditUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const user = useSelector((state) => state.auth.user);

  console.log(id);

  useEffect(() => {
    dispatch(getUserById(id));
  }, [dispatch, id]);

  const initialValues = {
    name: user?.name || "",
    user: user?.user || "",
    email: user?.email || "",
    password: user?.password || "",
    role: user?.role || "",
    residence: user?.residence || "",
    directory: user?.directory || "",
    personal_nr: user?.personal_nr || "",
    position: user?.position || "",
    id: id,
  };

  return (
    <div className="p-6">
      <h1 className="py-6 text-blue-900 font-semibold">Shto User</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const userData = {
            name: values.name,
            user: values.user,
            email: values.email,
            password: values.password,
            role: values.role,
            directory: values.directory,
            personal_nr: values.personal_nr,
            position: values.position,
          };

          dispatch(updateUser({ id, userData }));
          navigate("/users");
        }}
        enableReinitialize
      >
        {({ errors, touched, handleChange, values }) => (
          <Form className="space-y-4 text-xs">
            <Input
              label="Emri"
              id="name"
              value={values.name}
              onChange={handleChange}
              name="name"
              placeholder="Emri"
              error={errors.name && touched.name ? errors.name : null}
            />
            <Input
              label="Useri"
              id="user"
              value={values.user}
              onChange={handleChange}
              name="user"
              placeholder="Useri"
              error={errors.user && touched.user ? errors.user : null}
            />
            <Input
              label="Email"
              id="email"
              type="email"
              value={values.email}
              onChange={handleChange}
              name="email"
              placeholder="Emaili"
              error={errors.email && touched.email ? errors.email : null}
            />
            <Input
              label="Password"
              id="password"
              type="password"
              value={values.password}
              onChange={handleChange}
              name="password"
              placeholder="Password"
              error={
                errors.password && touched.password ? errors.password : null
              }
            />
            <Input
              label="Roli"
              id="role"
              value={values.role}
              onChange={handleChange}
              name="role"
              placeholder="Roli"
              error={errors.role && touched.role ? errors.role : null}
            />

            <Input
              label="Residenca"
              id="residence"
              value={values.residence}
              onChange={handleChange}
              name="residence"
              placeholder="Residenca"
              error={
                errors.residence && touched.residence ? errors.residence : null
              }
            />
            <Input
              label="Directory"
              id="directory"
              value={values.directory}
              onChange={handleChange}
              name="directory"
              placeholder="Directory"
              error={
                errors.directory && touched.directory ? errors.directory : null
              }
            />
            <Input
              label="Personal Number"
              id="personal_nr"
              value={values.personal_nr}
              onChange={handleChange}
              name="personal_nr"
              placeholder="Personal Number"
              error={
                errors.personal_nr && touched.personal_nr
                  ? errors.personal_nr
                  : null
              }
            />
            <Input
              label="Position"
              id="position"
              value={values.position}
              onChange={handleChange}
              name="position"
              placeholder="Position"
              error={
                errors.position && touched.position ? errors.position : null
              }
            />
            <div className="flex justify-end">
              <Link to="/household">
                <button
                  type="button"
                  className="px-4 py-2 mr-2 bg-white text-[#28ABE2] rounded-md"
                >
                  Anulo
                </button>
              </Link>
              <button
                type="submit"
                className="px-12 py-2 bg-[#2FBFDE] text-white rounded-md"
              >
                Ruaj
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
